<template>
  <div class="toast-container">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      :class="['toast-item', `toast-${toast.type}`]"
    >
      <div class="toast-icon">
        <i :class="getIcon(toast.type)"></i>
      </div>
      <div class="toast-content">
        <div class="toast-message">{{ toast.message }}</div>
      </div>
      <button class="toast-close" @click="removeToast(toast.id)">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToastNotification",
  data() {
    return {
      toasts: [],
      nextId: 1,
    };
  },
  methods: {
    show(message, type = "info", duration = 3000) {
      const id = this.nextId++;
      this.toasts.push({ id, message, type });

      if (duration > 0) {
        setTimeout(() => {
          this.removeToast(id);
        }, duration);
      }
    },
    removeToast(id) {
      const index = this.toasts.findIndex((t) => t.id === id);
      if (index > -1) {
        this.toasts.splice(index, 1);
      }
    },
    getIcon(type) {
      const icons = {
        success: "fas fa-check-circle",
        error: "fas fa-exclamation-circle",
        warning: "fas fa-exclamation-triangle",
        info: "fas fa-info-circle",
      };
      return icons[type] || icons.info;
    },
  },
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 100001;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}

.toast-item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 300px;
  max-width: 500px;
  padding: 16px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: all;
  border-left: 4px solid;
}

.toast-success {
  border-left-color: #82d616;
}

.toast-error {
  border-left-color: #ea0606;
}

.toast-warning {
  border-left-color: #fb6340;
}

.toast-info {
  border-left-color: #11cdef;
}

.toast-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.toast-success .toast-icon {
  color: #82d616;
}

.toast-error .toast-icon {
  color: #ea0606;
}

.toast-warning .toast-icon {
  color: #fb6340;
}

.toast-info .toast-icon {
  color: #11cdef;
}

.toast-content {
  flex: 1;
}

.toast-message {
  font-size: 14px;
  font-weight: 600;
  color: #344767;
  line-height: 1.5;
}

.toast-close {
  background: none;
  border: none;
  color: #8392ab;
  cursor: pointer;
  padding: 4px;
  font-size: 16px;
  transition: color 0.2s;
  flex-shrink: 0;
}

.toast-close:hover {
  color: #344767;
}

/* Animations */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
</style>
